/* @flow */

import React, { useEffect } from "react";
import Cookies from "js-cookie";

type EventOptions = { [string]: number | string };
type ReturnValue = {
  event: (name: string, options: EventOptions) => void,
  send: () => void,
};

const RETRACK_PROPERTY = "re";

let retrackScript: HTMLScriptElement | null = null;

const useRetrack = (): ReturnValue => {
  const retrackCookie = Cookies.get("retrackEvent");

  const init = () => {
    if (retrackScript) {
      cleanup();
    }

    /* eslint-disable-next-line prefer-arrow/prefer-arrow-functions */
    window[RETRACK_PROPERTY] = function () {
      window[RETRACK_PROPERTY].q.push(arguments);
    };

    window[RETRACK_PROPERTY].q = [];

    const script = document.createElement("script");
    const head = document.querySelector("head");
    script.src = "https://retrack-app.com/track/v2/script";
    script.async = true;
    head?.append(script);

    retrackScript = script;
  };

  const cleanup = () => {
    if (retrackScript) {
      retrackScript.remove();
    }

    delete window[RETRACK_PROPERTY];
    retrackScript = null;
  };

  const callRetrack = (...args: Array<any>) => {
    if (typeof window === "undefined") {
      return;
    }

    if (typeof window[RETRACK_PROPERTY] === "undefined" && retrackCookie) {
      init();
    }

    return window[RETRACK_PROPERTY].apply(null, args);
  };

  const event = (name: string, options: EventOptions) => {
    callRetrack(name, options);
  };

  const send = () => {
    callRetrack("send");
  };

  useEffect(() => {
    return () => {
      cleanup();
    };
  }, []);

  return { event, send };
};

export default useRetrack;
